module.exports = __webpack_public_path__ + "static/media/i0x4_temp.dc5bdc61.jpg";